import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import UI from '../../components/ExcerciseTypes/Design/UserInterface'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'

const json = {
	1: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P34-E1',
		audio: '',
		hideBtnFooter: true,
		// exerciseKey: 'img/FriendsPlus/Page7/Key/E1answerKey.png',
		component: T6,
		inputSize: 250,
		textAlign: 'center',
		maxLength: 18,

		titleQuestion: [
			{
				num: '1',
				title: 'Read.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
       
            <div> <img style='width:22cm' src='img/FriendsPlus/Page34/E1/1.jpg' /> </div>
          `,
				answer: [''],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P34-E2',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page34/E2/Key/E2answerKey.png',
		component: T6,
		inputSize: 500,
		textAlign: 'left',
		maxLength: 30,
		stylesTextInput: {
			background: 'none',
			// borderBottom: "none",
			fontSize: 22,
			height: 27,
			// textTransform: 'uppercase',
		},
		titleQuestion: [
			{
				num: '2',
				title:
					'Read again. Circle two things students can do. Underline two things they can’t do.',
				color: '#234090',
			},
		],
		questions: [
			{
				title: `	
        <div> 
          <img style='width:18cm' src='img/FriendsPlus/Page34/E1/1.jpg' /> 
          <div style='margin-left: 50px;display:flex; flex-direction: column; '>
              <b>ANSWER:</b>
              <b>Two things students can do:</b>
              <div>- #</div>
              <div>- #</div>
              <b>Two things students can't do:</b>
              <div>- #</div>
              <div>- #</div>
          </div>
        </div>
          `,
				answer: [
					'play ball games/Play ball games',
					'talk with friends/Talk with friends',
					'ride bikes/Ride bikes',
					'throw trash on the ground/Throw trash on the ground',
				],
			},
		],
	},
	3: {
		// Exercise num
		unit: 'Unit 4',
		id: '4WB-U4-P34-E3',
		audio: '',
		video: '',
		exerciseKey: 'img/FriendsPlus/Page34/E3/Key/E3answerKey.png',

		component: DesignUnderLine,
		totalInput: 3,
		titleQuestion: [
			{
				num: '3',
				title: 'Read again. Fill in the correct circle.',
				color: '#234090',
			},
		],
		// isAllowSubmit: false,
		questionImage: [
			[{ url: 'img/FriendsPlus/Page34/E3/1.jpg' }],
			[{ url: 'img/FriendsPlus/Page34/E3/2.jpg' }],
			// Row 1
			[
				{ url: 'img/FriendsPlus/Page34/E3/3.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/4.jpg', input: 1, isCorrect: true },
				{ url: 'img/FriendsPlus/Page34/E3/5.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/6.jpg', input: 1 },
				{ url: 'img/FriendsPlus/Page34/E3/7.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/8.jpg', input: 1 },
				{ url: 'img/FriendsPlus/Page34/E3/9.jpg' },
			],
			// Row 2
			[{ url: 'img/FriendsPlus/Page34/E3/10.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page34/E3/11.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/12.jpg', input: 2 },
				{ url: 'img/FriendsPlus/Page34/E3/13.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/14.jpg', input: 2, isCorrect: true },
				{ url: 'img/FriendsPlus/Page34/E3/15.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/16.jpg', input: 2 },
				{ url: 'img/FriendsPlus/Page34/E3/17.jpg' },
			],
			// Row 3
			[{ url: 'img/FriendsPlus/Page34/E3/18.jpg' }],
			[
				{ url: 'img/FriendsPlus/Page34/E3/19.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/20.jpg', input: 3 },
				{ url: 'img/FriendsPlus/Page34/E3/21.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/22.jpg', input: 3 },
				{ url: 'img/FriendsPlus/Page34/E3/23.jpg' },
				{ url: 'img/FriendsPlus/Page34/E3/24.jpg', input: 3, isCorrect: true },
				{ url: 'img/FriendsPlus/Page34/E3/25.jpg' },
			],
			[{ url: 'img/FriendsPlus/Page34/E3/26.jpg' }],
		],
	},
}

export default json
